<template>
    <div class="side-menu">
        <span class="menu-item" @click="pushFlightLog">Flugbuch</span>
        <span class="menu-item" @click="pushChangePasswort">Passwort ändern</span>
    </div>
</template>
<script>
import { useRouter } from 'vue-router'
import { useStore } from 'vuex'

export default {
    name: 'Menu', 
    props: ['compName'],

    setup(props, context) {
        const router = useRouter()
        const store = useStore()
        const pushChangePasswort = () => {
            if (props.compName === "ChangePassword") {
                context.emit('closeMenu');
            } else {
                router.push({ name: "ChangePassword" })
            }
        }
        
        const pushFlightLog = () => {
          if (props.compName === 'Home') {
            context.emit('closeMenu');
          } else {
            router.push({ name: "Home" })
          }
        }
        
        return{pushChangePasswort,pushFlightLog}
    }
}
</script>

<style scoped>
 .side-menu {
    padding-top: 20px;
    height:100%;
    width:205px;
    position:fixed;
    z-index:1;
    top: 100;
    left:0;
    background: #333;
    overflow-x: hidden;
 }

 .menu-item {
    padding: 15px 15px 10px 30px;
    font-size: 16px;
    color: #fff;
    display: block;
    text-align: left;

 }

</style>
